import React, { CSSProperties } from 'react';
import { useSelector } from 'react-redux';
import { get, includes } from 'lodash';
import { watermarkBrandImageSelector } from './../../../../Common/Common.selector';
import styles from './BrandImage.module.css';

const BrandImage = ({ floId, floIndex }: { floId: string; floIndex: number }) => {
	const imageSource = useSelector(watermarkBrandImageSelector(floIndex));

	const imageStyles = useSelector((state) => {
		const position = get(state, 'routerContainer.brandPosition', 'bottom-right');
		const styles: CSSProperties = {};
		if (includes(position, 'bottom')) {
			styles.bottom = 0;
		}
		if (includes(position, 'top')) {
			styles.top = 0;
		}
		if (includes(position, 'left')) {
			styles.left = 0;
		}
		if (includes(position, 'right')) {
			styles.right = 0;
		}
		return styles;
	});
	if (!imageSource) {
		return <span></span>;
	}

	return (
		<div className={styles.brandImage} style={imageStyles}>
			<img src={imageSource} alt="brandImage" />
		</div>
	);
};

export default BrandImage;
